import { TrainingView } from "@my-helpers/common";
import { Card, CardContent, Typography } from "@mui/material";
import { Settings } from "@mui/icons-material";

interface TrainingAdditionalInfoProps {
    training?: TrainingView;
}

const TrainingAdditionalInfo: React.FC<TrainingAdditionalInfoProps> = ({ training }) => {
    return (
        <Card sx={{ height: '100%', flex: 1 }}>
            <CardContent sx={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                color: 'text.secondary'
            }}>
                <Settings sx={{ fontSize: '2.5rem', mb: 2, opacity: 0.3 }} />
                <Typography variant="h6" sx={{ mb: 1, fontSize: '1.1rem' }}>
                    Additional Information
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.5, textAlign: 'center' }}>
                    This space is reserved for future features
                </Typography>
            </CardContent>
        </Card>
    );
};

export default TrainingAdditionalInfo;
